
<template>
  <div id="app">
    <navigation v-if="enterRecord === 'maker'" />
    <navigation2 v-if="enterRecord === 'maker2'" />
    <router-view />
  </div>
</template>
<script>
import axios from "axios";
import navigation from "@/components/navigation.vue";
import navigation2 from "@/components/navigation2.vue";
import { getBgColors } from "@/utils/api";
import { zhpollify } from "@/utils/compatible.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      enterRecord: "",
    };
  },
  // computed: mapState({
  //   navState: (state) => state.navState,
  // }),
  watch: {
    $route(to, from, next) {
      if (["maker", "maker2"].includes(to.name)) {
        sessionStorage.setItem("enterRecord", to.name);
        this.enterRecord = to.name;
      } else if (sessionStorage.getItem("enterRecord")) {
        this.enterRecord = sessionStorage.getItem("enterRecord");
      }
    },
  },
  components: {
    navigation,
    navigation2,
  },
  methods: {
    async initBgColors() {
      let colorsArr = await getBgColors();
      this.$store.state.colors = colorsArr.result.map((item) => {
        return {
          ...item,
          s_color: item.start_color.toString(16).padStart(6, 0),
          e_color: item.enc_color.toString(16).padStart(6, 0),
        };
      });
    },
  },
  created() {
    axios.defaults.baseURL = this.$store.state.baseApiUrl;
    // this.initBgColors();
    zhpollify();
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
